export const SchemeData = [
  {
    title: 'DRIVES',
    description: 'Brand<br>Growth',
  },
  {
    title: 'ALIGNS TO',
    description: 'Brand<br>Strategy',
  },
  {
    title: 'ACCELERATES',
    description: 'Recruitment',
  },
  {
    title: 'MANAGES',
    description: 'Performance<br>Risks',
  },
  {
    title: 'REINFORCES',
    description: 'Consumer<br>Centricity',
  },
  {
    title: 'ENSURES',
    description: 'Scalability',
  },
  {
    title: 'MEASURES',
    description: 'The<br>Effectiveness<br>of Investment',
  },
  {
    title: 'FEATURES',
    description: 'An<br>Enterprise<br>Effort',
  },
]
